<h2 mat-dialog-title>Reset Password</h2>
<mat-dialog-content>
    <p class="description">
        Enter your email address and we'll send you a link to reset your password.
    </p>
    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput [formControl]="emailControl" placeholder="user@example.com">
        <mat-error *ngIf="emailControl.hasError('required')">Email is required</mat-error>
        <mat-error *ngIf="emailControl.hasError('email')">Invalid email format</mat-error>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="primary" [disabled]="emailControl.invalid || loading" (click)="sendResetLink()">
        {{ loading ? 'Sending...' : 'Send Link' }}
    </button>
</mat-dialog-actions>